export default {
    xygkConfig:'/index.php/cqh/Xygk/Get',// 区县概括配置
    xygkSave:'/index.php/cqh/Xygk/Save',// 区县概括保存
    xygkGet:'/index.php/cqh/Xygk/Get',// 区县概括获取
}